import LxcError from "~/core/models/LxcError.class";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";
import dtwinsService from "~/modules/dtwin/services/dtwin.service";
import { useDtwinModelsStore } from "~/modules/dtwin/stores/useDtwinModelsStore";

export function useFetchDtwinModels({ organizationCode }: UseFetchParameters) {
  const results: Ref<DtwinModel[] | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);

  async function fetchAll(useCache?: boolean) {
    isLoading.value = true;

    const { dtwinModels, setDtwinModels } = useDtwinModelsStore();
    if (useCache && dtwinModels) {
      results.value = dtwinModels;
      isLoading.value = false;
    } else {
      const response =
        await dtwinsService.getOrganizationAllDtwinModels(organizationCode);

      if (LxcError.check(response)) {
        results.value = undefined;
        error.value = response;
      } else {
        error.value = undefined;
        results.value = response;
        setDtwinModels(response);
      }
    }

    isLoading.value = false;
  }

  return {
    results,
    isLoading,
    error,
    fetchAll,
  };
}
